import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
// 系统
import sys from './sys';
// 设备
import device from './m_device';
// 售后
import after_sales from './m_after_sales';
// air
import air from './m_air';
// eco
import eco from './m_eco';
// ene
import ene from './m_ene';
// zt
import zt from './m_zt';
// old
import tables from './tables';
// full_page 全屏页面
import full_page from './m_full_page';
// all
import viewgird from './viewGird';
// vol
import form from './form';
import formsMulti from './formsMulti';
import redirect from './redirect';
import charts from './charts';
import store from '../store/index';
import runtimeConfig from '@/api/runtimeConfig';
import http from '@/api/http';
const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index'),
    // 回首页
    // redirect: '/home',
    // redirect: '/MapView',
    redirect: (to) => {
      return runtimeConfig.homePath;
    },
    children: [
      ...sys, // 系统路由
      ...device, // 设备路由
      ...after_sales, // 售后路由
      ...air, // air路由
      ...eco, // eco路由
      ...ene, // ene路由
      ...zt, // zt组态路由
      ...tables, //tables
      ...viewgird, // 全部路由
      ...form, //Demo表单路由
      ...formsMulti, //
      ...redirect,
      ...charts,
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/UserInfo',
        name: 'UserInfo',
        component: () => import('@/views/system/UserInfo.vue')
      },
      {
        path: '/sysMenu',
        name: 'sysMenu',
        component: () => import('@/views/system/Sys_Menu.vue')
      },
      {
        path: '/coder',
        name: 'coder',
        component: () => import('@/views/builder/coder.vue')
      },
      {
        path: '/formDraggable', //表单设计
        name: 'formDraggable',
        component: () => import('@/views/formDraggable/formDraggable.vue')
      },
      {
        path: '/formSubmit', //表单提交页面
        name: 'formSubmit',
        component: () => import('@/views/formDraggable/FormSubmit.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/formCollectionResultTree', //显示收集的数据表单
        name: 'formCollectionResultTree',
        component: () => import('@/views/formDraggable/FormCollectionResultTree.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/signalR',
        name: 'signalR',
        component: () => import('@/views/signalR/Index.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/flowdemo', //发起流程示例
        name: 'flowdemo',
        component: () => import('@/views/system/flow/FlowDemo.vue'),
        meta: {
          keepAlive: false
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      anonymous: true
    }
  },
  ...full_page, // full_page 全屏页面路由
  {
    path: '/app/guide',
    name: 'apphome',
    meta: {
      anonymous: true
    },
    component: () => import('@/views/h5/Guide.vue')
  },
  {
    path: '/bigdata',
    name: 'bigdata',
    component: () => import('@/views/charts/bigdata.vue'),
    meta: {
      keepAlive: false
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(), //createWebHistory(process.env.BASE_URL),
  routes
});

// sso登录:shaun:2025-10-23
router.beforeEach((to, from, next) => {
  if (to.matched.length == 0) return next({ path: '/404' });
  //2020.06.03增加路由切换时加载提示
  store.dispatch('onLoading', true);
  const isAnonymous = to.matched.some((r) => r.meta && r.meta.anonymous);
  const isSsoCallback = to.matched.some((r) => r.path === '/sso/callback' || r.name === 'ssoCallback');

  // 如果启用认证中心登录
  if (runtimeConfig.authType) {
    // 访问客户端 /login 时统一跳到 SSO 登录页，实现单点登录
    if (to.path === '/login') {
      const url = `${runtimeConfig.authBase}#/login?client_id=${encodeURIComponent(runtimeConfig.clientId)}&redirect_uri=${encodeURIComponent(runtimeConfig.redirectUri)}`;
      window.location.href = url;
      return;
    }

    if (isAnonymous || isSsoCallback || store.getters.isLogin()) {
      return next();
    }

    // 未登录且非匿名页面，跳转到 SSO 登录
    const url = `${runtimeConfig.authBase}#/login?client_id=${encodeURIComponent(runtimeConfig.clientId)}&redirect_uri=${encodeURIComponent(runtimeConfig.redirectUri)}`;
    window.location.href = url;
  } else {
    // 使用本地登录
    if (isAnonymous || store.getters.isLogin()) {
      return next();
    }
    // 未登录且非匿名页面，跳转到本地登录
    next({ path: '/login', query: { redirect: to.fullPath } });
  }
});
router.afterEach((to, from) => {
  store.dispatch('onLoading', false);
});
router.onError((error) => {
  // const targetPath = router.currentRoute.value.matched;
  try {
    console.log(error.message);
    if (process.env.NODE_ENV == 'development') {
      alert(error.message);
    }
    localStorage.setItem('route_error', error.message);
  } catch (e) {}
  window.location.href = '/';
});
export default router;
